import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const PrivacyPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center" fontWeight="bold">
          POLÍTICA DE PRIVACIDADE E PROTEÇÃO DE DADOS DA PLATAFORMA ADVOGADA PARCEIRA
        </Typography>
        
        <Typography variant="subtitle1" gutterBottom align="center" fontStyle="italic" color="error">
          Lembrete: Ao utilizar a Plataforma, a Usuária concorda integralmente com esta Política de Privacidade e Proteção de Dados. Em caso de discordância com os termos aqui estabelecidos, recomenda-se a não utilização da Plataforma.
        </Typography>
        
        <Box mt={3}>
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Introdução
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Parceira Tecnologia Ltda., inscrita no CNPJ/MF sob o nº 60.060.220/0001-32 ("Advogada Parceira"), é uma empresa especializada em soluções tecnológicas voltadas para o universo jurídico. Seu objetivo é facilitar e aprimorar o trabalho de profissionais e organizações por meio de ferramentas inteligentes e inovadoras. O sistema desenvolvido pela Advogada Parceira será doravante denominado "Plataforma".
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira acredita que a privacidade, a segurança e a confiança são fatores fundamentais para a relação com suas usuárias, assim entendidas como as pessoas físicas ou jurídicas que assinarem um dos pacotes oferecidos (as "Usuárias"). Assim, a Advogada Parceira criou esta Política de Privacidade e Proteção de Dados (a "Política de Privacidade"), para que cada Usuária compreenda, de forma clara e descomplicada, como seus dados e informações são tratados e protegidos.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Recomendamos a leitura atenta desta Política. O intuito é garantir que ela seja acessível e de fácil entendimento. Contudo, caso surjam dúvidas, você pode entrar em contato com o nosso setor de Proteção de Dados por meio do e-mail: suporte@advogadaparceira.com.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Algumas Definições
          </Typography>
          
          <Typography variant="body1" paragraph>
            Esta Política de Privacidade tem como finalidade esclarecer as regras aplicáveis à coleta, uso e transferência de Dados Pessoais, afirmando o compromisso da Advogada Parceira com as Usuárias e o cumprimento das normas de proteção de dados.
          </Typography>
          
          <Typography variant="body1" paragraph>
            O pilar desta Política de Privacidade é a Lei n° 13.709/2018 (Lei Geral de Proteção de Dados Pessoais – "LGPD"). Por isso, é importante apresentar, de forma resumida, alguns conceitos trazidos pela LGPD, que serão importantes para a compreensão e interpretação desta Política de Privacidade:
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Autoridade Nacional de Proteção de Dados (ANPD)</strong> é uma autarquia federal, criada pela LGPD, a quem compete zelar pela proteção dos Dados Pessoais, na forma da lei.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Consentimento</strong> significa a manifestação feita de forma livre, informada e inequívoca, por meio da qual o Titular de Dados Pessoais concorda com o tratamento de seus Dados Pessoais para uma finalidade determinada.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Dado Pessoal</strong> significa qualquer informação relacionada a uma pessoa natural (física) identificada ou identificável. A LGPD não se aplica a dados de pessoas jurídicas.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Dado Pessoal Sensível</strong> significa qualquer dado pessoal que inclua uma ou mais das seguintes informações sobre uma pessoa natural: origem racial ou étnica; convicção religiosa; opinião política; filiação a sindicato ou a organização de caráter religioso, filosófico ou político; dado referente à saúde ou à vida sexual; dado genético ou biométrico. A Advogada Parceira não coletará Dados Pessoais Sensíveis de suas Usuárias.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Encarregado pelo Tratamento de Dados Pessoais</strong> significa o profissional – também conhecido como Data Protection Officer (DPO) – que atua como canal de comunicação entre a Conversion, os Titulares dos dados e a Autoridade Nacional de Proteção de Dados. Na Advogada Parceira, essa pessoa é Gregory Acacio Seibert Oliveira (suporte@advogadaparceira.com).
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Titular de Dados Pessoais</strong> significa a pessoa física a quem se referem os Dados Pessoais. No caso específico da Advogada Parceira, toda Usuária que for uma pessoa física será Titular de Dados Pessoais nos termos desta Política de Privacidade. Ao longo deste documento, a Titular de Dados Pessoais será denominada "Titular".
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Tratamento de Dados Pessoais</strong> significa qualquer operação realizada com os Dados Pessoais de um Titular (como, por exemplo: a coleta, recepção, utilização, distribuição, armazenamento, eliminação, etc.).
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Objetivo desta Política de Privacidade
          </Typography>
          
          <Typography variant="body1" paragraph>
            Esta Política de Privacidade tem o propósito de demonstrar de que forma a Advogada Parceira se preocupa com a privacidade de suas Usuárias e realiza o tratamento dos seus Dados Pessoais.
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira compromete-se a seguir os princípios estabelecidos pela LGPD, garantindo a aplicação de práticas que promovam a privacidade e a proteção de dados suas operações. Adotamos os conceitos de "Privacy by Design" e "Privacy by Default", o que significa que a privacidade dos dados pessoais das Usuárias e de seus clientes [e de terceiros cujos dados sejam fornecidos pelos Usuários] é considerada desde a concepção dos nossos serviços, com as configurações mais seguras aplicadas por padrão.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Os princípios seguidos pela Advogada Parceira no tratamento de Dados Pessoais incluem:
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Finalidade:</strong> O Tratamento de Dados Pessoais é realizado para objetivos legítimos, específicos e claros, devidamente informados à Titular.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Necessidade:</strong> Somente coletamos e tratamos os dados estritamente necessários para atender às finalidades pretendidas.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Adequação:</strong> Garantimos que o Tratamento de Dados Pessoais é adequado à finalidade informada à Titular, respeitando o contexto de sua utilização.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Segurança:</strong> Adotamos medidas técnicas e administrativas para proteger os Dados Pessoais contra acessos não autorizados, vazamentos, ou qualquer outra forma de tratamento inadequado.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Transparência:</strong> Garantimos que as informações sobre o tratamento de Dados Pessoais sejam claras, acessíveis e facilmente compreensíveis.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Esses princípios são aplicados em todas as etapas do tratamento de dados, garantindo o respeito à privacidade e aos direitos dos titulares.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Quais dados são coletados e para qual finalidade?
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira realiza a coleta e o Tratamento de Dados Pessoais de suas Usuárias, em conformidade com a LGPD e com boas práticas de governança corporativa.
          </Typography>
          
          <Typography variant="body1" paragraph>
            As finalidades do Tratamento de Dados Pessoais fornecidos pela Usuárias são:
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Cadastro:</strong> Cadastrar informações para identificação da Usuária e cumprimento das obrigações decorrentes da prestação dos serviços pela Advogada Parceira.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Obrigações Legais:</strong> Cumprir obrigações legais e regulatórias previstas no ordenamento jurídico brasileiro.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Contato:</strong> Possibilitar o contato entre Advogada Parceira e as Usuárias, a fim de mantê-las informadas sobre atualizações em nossos serviços, de divulgar conteúdos de valor por e-mail e por mensagens automatizadas no celular, realizar solicitações, bem como qualquer outra necessidade comunicativa percebida entre as duas partes.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Estudos:</strong> Possibilitar estudos de público para a criação de anúncios/propagandas, com base em boas práticas de segmentação do público e visando à melhor experiência da Usuária.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Feedbacks e melhorias:</strong> A Advogada Parceira valoriza o retorno das Usuárias sobre seus serviços e funcionalidades. Coletamos e utilizamos feedbacks para aprimorar continuamente a Plataforma, ajustando-a conforme as necessidades e sugestões dos nossas Usuárias, e permitindo o aprimoramento da qualidade do serviço prestado.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Uploads, anexação e salvamento de documentos na Plataforma:</strong> A Advogada Parceira permite que as Usuárias façam o upload/anexação e que salvem documentos na Plataforma, sejam esses documentos criados com auxílio da Advogada Parceira ou não. Esses documentos são armazenados de maneira segura para utilização nas funcionalidades dos nossos serviços, e sua proteção é uma prioridade para nós. Os dados contidos nesses arquivos também são tratados conforme esta Política de Privacidade.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Pagamentos:</strong> Assegurar o pagamento da prestação dos serviços da Advogada Parceira e prevenir eventuais divergências ou dificuldades para as partes.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Defesa:</strong> Assegurar o direito de defesa em caso de eventuais disputas judiciais ou exigências administrativas ou judiciais.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Ao longo da experiência de uso na Plataforma, podem ser solicitados e armazenados dados de faturamento (CPF/CNPJ, endereço, etc.) com o objetivo de cadastro financeiro para emissões de notas fiscais.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Como os meus dados são coletados?
          </Typography>
          
          <Typography variant="body1" paragraph>
            Ao realizar uma das ações abaixo descritas, a Usuária concede seu Consentimento ao Tratamento de Dados Pessoais fornecidos à Advogada Parceira:
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Na criação de uma conta na Plataforma:</strong> a Advogada Parceira coleta os Dados de identificação básicos da Usuária para acessar as funcionalidades da Plataforma. Esses dados podem ser: nome, endereço de e-mail, imagem, informações do escritório, telefone, etc.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>No acesso e utilização da Plataforma:</strong> durante o uso, informações inseridas e documentos anexados pela Usuária podem ser coletados e armazenados (incluindo, por exemplo, os dados utilizados na elaboração dos documentos e demais conteúdos).
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>No uso da funcionalidade de compartilhamento de documentos e nas demais funcionalidades de anexação de documentos:</strong> A Usuária pode anexar arquivos com a finalidade de gerenciamento de documentos e otimização da sua comunicação com o seu cliente. A Advogada Parceira não possui responsabilidade pelos documentos inseridos e gerenciados na Plataforma [ou pelo seu teor, incluindo, mas não se limitando a dados pessoais de clientes do Usuário ou de terceiros que este tenha fornecido para a confecção dos documentos], sendo tal responsabilidade da Usuária.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Além dos tópicos acima, que representam as principais formas de coleta de Dados Pessoais pela Advogada Parceira, outras formas de coleta são:
          </Typography>
          
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Campanhas de marketing;</li>
            <li>Dados manifestamente públicos;</li>
            <li>Formulário de contato no site;</li>
            <li>Inscrição nos nossos downloads de conteúdos;</li>
            <li>Inscrição em processo seletivo.</li>
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Quais são os meus direitos?
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira assegura às suas Usuárias o controle de seus Dados Pessoais coletados, tratados e armazenados. Com isso, a Usuária tem uma série de direitos, como:
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Confirmação de Dados:</strong> você pode solicitar a confirmação da existência de tratamento de seus Dados Pessoais em formato simplificado ou por meio de declaração clara e completa.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Acesso aos Dados:</strong> você pode solicitar uma cópia de seus Dados Pessoais fornecidos em um formato legível sob a forma impressa ou por meio eletrônico, seguro e idôneo.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Correção de Dados:</strong> você pode solicitar a edição, correção e atualização de Dados incompletos, inexatos ou desatualizados.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Limitação dos Dados:</strong> você pode solicitar o bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a LGPD, ressalvada a manutenção dos dados essenciais para o cumprimento de dever legal e ao exercício do direito de defesa em processo judicial e/ou administrativo.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>Revogação do Consentimento:</strong> você pode, a qualquer tempo, revogar o consentimento para o Tratamento de Dados Pessoais pela Advogada Parceira, e, em tal ocasião, será informada sobre as consequências da negativa.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Encerrada a relação contratual ou revogado o consentimento para Tratamento dos Dados Pessoais, todas as informações de natureza pessoal coletadas, tratadas e armazenadas pela Advogada Parceira serão eliminadas, exceto os registros necessários ao cumprimento do dever legal e ao exercício do direito de defesa em eventual processo judicial e/ou administrativo.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Como e por quanto tempo meus dados são utilizados e armazenados?
          </Typography>
          
          <Typography variant="body1" paragraph>
            Ao coletar seus Dados Pessoais, a Advogada Parceira se compromete a armazená-los em condições técnicas e estruturais seguras, conforme os mais altos padrões técnicos adequados de tecnologia da informação e segurança de dados.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Os Dados Pessoais são armazenados no banco de dados AWS RDS, ou, quando cabível, no banco de dados de terceiros parceiros, seguindo os mais altos padrões de segurança.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Esses Dados Pessoais serão mantidos enquanto a relação contratual entre a Usuária e a Advogada Parceira estiver vigente e por um período adicional de 6 (seis) meses a 5 (cinco) anos após o término dessa relação, conforme a natureza dos dados e as exigências legais aplicáveis.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Como posso solicitar a alteração ou exclusão dos meus dados?
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Usuária pode solicitar a retificação e/ou alteração de seus Dados Pessoais ou revogar o Consentimento para o tratamento de seus Dados Pessoais a qualquer tempo. Para isso, a Advogada Parceira disponibiliza às Usuárias um canal exclusivo para requerimentos acerca de dados pessoais, no seguinte e-mail:
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ textAlign: 'center', fontWeight: 'bold' }}>
            suporte@advogadaparceira.com
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Com quem meus Dados Pessoais são compartilhados?
          </Typography>
          
          <Typography variant="body1" paragraph>
            Os Dados Pessoais das Usuárias dos serviços oferecidos pela Advogada Parceira só poderão ser compartilhados com terceiros nas hipóteses de:
          </Typography>
          
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Contratação de serviços de terceiros (operadores) que realizem o tratamento de Dados Pessoais das Usuárias da Advogada Parceira, como sistemas de armazenamento e hospedagem de dados, serviços de computação em nuvem, serviços de publicidade e Marketing, serviços de administração e controle financeiro (faturamento de crédito), serviços de telecomunicações, serviços de inteligência artificial;</li>
            <li>Sucessão empresarial, como a fusão, aquisição ou incorporação; bem como hipóteses de transações e alterações societárias.</li>
            <li>Exigência de autoridades administrativas, judiciais ou policiais, mediante ordem válida e emitida por Órgão competente.</li>
            <li>Proteção dos direitos da Advogada Parceira em qualquer tipo de conflito, incluindo conflitos judiciais.</li>
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            O que fazemos para manter os Dados Pessoais seguros?
          </Typography>
          
          <Typography variant="body1" paragraph>
            A segurança no tratamento de Dados Pessoais de nossas Usuárias é prioridade para a Advogada Parceira. Dessa forma, seguimos os mais altos padrões de segurança cibernética para a proteção de dados. A Advogada Parceira permite o acesso aos dados coletados apenas a pessoas, naturais ou jurídicas, previamente estabelecidas, na forma desta Política de Privacidade, sendo vedado o acesso de outros que não os autorizados.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Uso de Cookies
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira faz uso de Cookies.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Cookies são arquivos de texto enviados pela Plataforma ao seu computador e que nele se armazenam, coletando informações relacionadas à navegação do site. Em suma, os Cookies são utilizados para aprimorar a experiência de uso da Plataforma. Ao acessar nosso site, você manifesta aceitar a utilização de um sistema de coleta de dados de navegação com o uso de Cookies em seu dispositivo.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Responsabilidades
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Isenção de responsabilidade
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira se isenta de qualquer responsabilidade relacionada à negligência, imprudência ou imperícia de suas Usuárias no manuseio de seus Dados Pessoais e dos Dados Pessoais de seus clientes ou de terceiros, limitando-se a garantir a segurança dos dados coletados e armazenados e o cumprimento das finalidades descritas nesta Política de Privacidade.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Responsabilidades da Advogada Parceira
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira compromete-se a:
          </Typography>
          
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Observar e zelar pelo cumprimento da presente Política de Privacidade;</li>
            <li>Manter esta Política atualizada;</li>
            <li>Buscar condições técnicas seguras para o Tratamento dos Dados;</li>
            <li>Receber reclamações e esclarecer dúvidas relativas a esta Política e a sua aplicação;</li>
            <li>Observar e adotar as providências previstas em comunicações da Autoridade Nacional de Proteção de Dados (ANPD).</li>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPage; 